import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-68f3d595"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home_contents_wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "home_title" }, "次のステップ", -1))
const _hoisted_3 = { class: "home_layout" }
const _hoisted_4 = { class: "home_interview_layout" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "home_interview_title" }, "面談・相談", -1))
const _hoisted_6 = { class: "home_interview_date" }
const _hoisted_7 = {
  key: 0,
  class: "home_interview_type_telephone"
}
const _hoisted_8 = {
  key: 1,
  class: "home_interview_type_web"
}
const _hoisted_9 = {
  key: 2,
  class: "home_interview_note"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "home_interview_note_text" }, "お時間になりましたらマスメディアンの担当者より携帯電話からご連絡いたします。", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "home_interview_note_text" }, "※ご入力いただいた携帯電話にお電話を差し上げます。", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "home_interview_note_text" }, "※自宅などプライバシーが守られる環境で電話相談を受けてください。", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "home_interview_note_text" }, "※時間は60分～90分程度を予定しております。", -1))
const _hoisted_14 = [
  _hoisted_10,
  _hoisted_11,
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = {
  key: 3,
  class: "home_interview_note"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "home_interview_note_text" }, "Web相談用のURLは面談当日の朝7時以降、こちらのマイページに表示されます。", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "home_interview_note_text" }, "※Web相談はGoogle Meetにて実施いたします。スマートフォンからご参加の場合は、「Googleアカウントの取得」と「アプリ（GmailもしくはGoogle Meet）のインストール」が必要となりますので、事前にご準備をいただけますと幸いです。", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "home_interview_note_text" }, "※自宅などプライバシーが守られる環境でWeb相談を受けてください。", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "home_interview_note_text" }, "※時間は60分程度を予定しております。", -1))
const _hoisted_20 = [
  _hoisted_16,
  _hoisted_17,
  _hoisted_18,
  _hoisted_19
]
const _hoisted_21 = {
  key: 4,
  class: "home_interview_note"
}
const _hoisted_22 = { class: "home_interview_note_text" }
const _hoisted_23 = ["href"]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "home_interview_note_text" }, "※Web相談はGoogle Meetにて実施いたします。スマートフォンからご参加の場合は、「Googleアカウントの取得」と「アプリ（GmailもしくはGoogle Meet）のインストール」が必要となりますので、事前にご準備をいただけますと幸いです。", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "home_interview_note_text" }, "※自宅などプライバシーが守られる環境でWeb相談を受けてください。", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "home_interview_note_text" }, "※時間は60分程度を予定しております。", -1))
const _hoisted_27 = { class: "home_interview_note_start" }
const _hoisted_28 = { class: "home_interview_note_start_button" }
const _hoisted_29 = ["href"]
const _hoisted_30 = { class: "home_interview_cancel" }
const _hoisted_31 = /*#__PURE__*/_createStaticVNode("<p class=\"home_layout_title_sencondary\" data-v-68f3d595>ご用意いただく書類</p><p class=\"home_layout_text\" data-v-68f3d595>面談・相談をより有意義なものにするため、以下の書類をお送りください。</p><p class=\"home_interview_list\" data-v-68f3d595>履歴書（顔写真添付）</p><p class=\"home_interview_list\" data-v-68f3d595>職務経歴書</p><p class=\"home_interview_list\" data-v-68f3d595>作品集や企画書など（クリエイティブ、プランナー職をご希望の方）</p><p class=\"home_layout_text\" data-v-68f3d595> ▼送付先 <br data-v-68f3d595> 【件名】「面談時の書類送付」 <br data-v-68f3d595> 【宛先】マスメディアン紹介事務局（ <a class=\"text_link\" target=\"_blank\" href=\"mailto:webmaster@massmedian.co.jp\" data-v-68f3d595>webmaster@massmedian.co.jp</a> ） </p><p class=\"home_layout_text_annotation\" data-v-68f3d595>ご本人確認のため、「氏名」「生年月日」をお書きください。</p><p class=\"home_layout_text_annotation\" data-v-68f3d595>作品集は表紙を含めて30ページ以内でお願いします。</p><p class=\"home_layout_text_annotation\" data-v-68f3d595> メールでのデータ容量は2MBまででお願いします。容量が大きい場合は大容量データ転送サービスをご利用ください。 </p><div class=\"home_layout_link\" data-v-68f3d595><a class=\"text_link\" href=\"https://www.massmedian.co.jp/service/flow/prepare.html\" target=\"_blank\" data-v-68f3d595>ご用意いただく書類の詳細 ＞</a></div><p class=\"home_layout_title_sencondary\" data-v-68f3d595>応募書類作成マニュアル</p>", 11)
const _hoisted_42 = { class: "home_manual_download" }
const _hoisted_43 = ["href"]
const _hoisted_44 = { class: "home_manual_download" }
const _hoisted_45 = ["href"]
const _hoisted_46 = { class: "home_manual_download" }
const _hoisted_47 = ["href"]
const _hoisted_48 = { class: "home_manual_download" }
const _hoisted_49 = ["href"]
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "home_title" }, "応募までの流れ", -1))
const _hoisted_51 = { class: "home_layout" }
const _hoisted_52 = /*#__PURE__*/_createStaticVNode("<div class=\"home_step\" data-v-68f3d595><a class=\"home_step_item home_step_item_size_large\" href=\"#jump_step_1\" data-v-68f3d595><span class=\"home_step_item_title home_step_item_size_large\" data-v-68f3d595>STEP1</span><span class=\"home_step_item_text\" data-v-68f3d595>キャリアシートの入力</span></a><a class=\"home_step_item\" href=\"#jump_step_2\" data-v-68f3d595><span class=\"home_step_item_title\" data-v-68f3d595>STEP2</span><span class=\"home_step_item_text\" data-v-68f3d595>面談・相談</span></a><a class=\"home_step_item\" href=\"#jump_step_3\" data-v-68f3d595><span class=\"home_step_item_title\" data-v-68f3d595>STEP3</span><span class=\"home_step_item_text\" data-v-68f3d595>求人のご紹介</span></a><a class=\"home_step_item home_step_item_size_large\" href=\"#jump_step_4\" data-v-68f3d595><span class=\"home_step_item_title\" data-v-68f3d595>STEP4</span><span class=\"home_step_item_text\" data-v-68f3d595>応募・書類選考</span></a><a class=\"home_step_item\" href=\"#jump_step_5\" data-v-68f3d595><span class=\"home_step_item_title\" data-v-68f3d595>STEP5</span><span class=\"home_step_item_text\" data-v-68f3d595>面接</span></a><a class=\"home_step_item\" href=\"#jump_step_6\" data-v-68f3d595><span class=\"home_step_item_title\" data-v-68f3d595>STEP6</span><span class=\"home_step_item_text\" data-v-68f3d595>内定・入社</span></a></div><div class=\"home_layout_title\" id=\"jump_step_1\" data-v-68f3d595>STEP1 キャリアシートの入力</div><p class=\"home_layout_text\" data-v-68f3d595>あなたの経歴や希望の職種・業種などを入力してください。</p><div class=\"home_layout_title\" id=\"jump_step_2\" data-v-68f3d595>STEP2 面談・相談</div><p class=\"home_layout_text_list\" data-v-68f3d595> マーケティング・クリエイティブを中心とした業界や、幅広い職種に精通したプロのキャリアコンサルタントが、これまでのご経歴やご希望をじっくりお伺いします。転職に関する疑問やお悩みなどのご相談も承っております。 </p><p class=\"home_layout_text_list\" data-v-68f3d595> 履歴書や職務経歴書などの書類ではわからないあなたの強みやご意向を把握し、応募企業にご推薦することで、書類選考通過率の向上に努めています。ぜひ、あなたのことを率直に教えてください。 </p><p class=\"home_layout_text_list\" data-v-68f3d595> 面談・相談は、Webもしくは電話にて対応しています。土日や平日の夜も受け付けています。所要時間は60分～90分程度です。 </p><p class=\"home_layout_text_list\" data-v-68f3d595>サービスはすべて無料で秘密厳守です。</p><p class=\"home_layout_title_sencondary\" data-v-68f3d595>面談・相談の流れ</p><p class=\"home_layout_tertiary\" data-v-68f3d595>1. マスメディアンの転職支援サービスをご説明</p><p class=\"home_layout_text\" data-v-68f3d595> キャリアコンサルタントが、マスメディアンの転職支援サービスや、転職までの流れについて詳しくご説明します。 </p><p class=\"home_layout_tertiary\" data-v-68f3d595>2. ご経歴のヒヤリング</p><p class=\"home_layout_text\" data-v-68f3d595> 履歴書や職務経歴書、ポートフォリオを見ながら、これまでの社会人経験を一緒に整理。あなたの強みを客観的に把握し、効果的な書類のつくり方もアドバイスします。 </p><p class=\"home_layout_tertiary\" data-v-68f3d595>3. ご希望のヒヤリング</p><p class=\"home_layout_text\" data-v-68f3d595>業界、職種、年収、待遇などのご希望をじっくり伺い、今後の方向性、キャリアプランを共有します。</p><p class=\"home_layout_tertiary\" data-v-68f3d595>4. ご相談・アドバイス</p><p class=\"home_layout_text\" data-v-68f3d595> ヒヤリングをもとに、一人ひとりにあったキャリアプランをご提案。目の前の転職の成功だけではなく、長いキャリアを見据えたアドバイスもいたします。時には、今のタイミングでの転職をおすすめしない場合も。 </p><p class=\"home_layout_tertiary\" data-v-68f3d595>5. 求人のご紹介</p><p class=\"home_layout_text\" data-v-68f3d595> キャリアプランをもとに、マーケティング・クリエイティブ職種など幅広い求人の中から、あなたにマッチした企業をご紹介します。 </p><p class=\"home_layout_text_annotation\" data-v-68f3d595> 希望・経験・職種・勤務地によっては求人の取り扱いがない場合があります。予めご了承ください。 </p><p class=\"home_layout_title_sencondary\" data-v-68f3d595>予約方法</p><p class=\"home_layout_text\" data-v-68f3d595>完全予約制です。ご都合に合わせて簡単にマイページからご予約ください。</p><p class=\"home_layout_title_sencondary\" data-v-68f3d595>ご用意いただく書類</p><p class=\"home_layout_text_document_list\" data-v-68f3d595>履歴書（顔写真添付）</p><p class=\"home_layout_text_document_list\" data-v-68f3d595>職務経歴書</p><p class=\"home_layout_text_document_list\" data-v-68f3d595>作品集や企画書など（クリエイティブ、プランナー職をご希望の方）</p><div class=\"home_layout_link\" data-v-68f3d595><a class=\"text_link\" href=\"https://www.massmedian.co.jp/service/flow/prepare.html\" target=\"_blank\" data-v-68f3d595>ご用意いただく書類の詳細 ＞</a></div><div class=\"home_layout_title\" id=\"jump_step_3\" data-v-68f3d595>STEP3 求人のご紹介</div><p class=\"home_layout_text\" data-v-68f3d595> 通常の求人には載っていない情報（企業の風土や職場環境、社長・社員の人柄など）もお伝えしながら、ご希望やご経験にあった求人をご紹介。人事部だけでなく、経営者や現場との人脈を持つマスメディアンにしかない特命・非公開求人も多いです。最近では一般企業の宣伝、広報、マーケティング、デジタル部門の求人も増加傾向にあります。 </p><div class=\"home_layout_title\" id=\"jump_step_4\" data-v-68f3d595>STEP4 応募・書類選考</div><p class=\"home_layout_text_list\" data-v-68f3d595>興味のある求人企業があればあなたを推薦し、選考に進みます。</p><p class=\"home_layout_text_list\" data-v-68f3d595>通常、1週間程度で、選考結果が判明します。結果はわかり次第、お知らせします。</p><p class=\"home_layout_text_list\" data-v-68f3d595> 人気のある求人ほどすぐに採用が決まります。ご紹介後3日以内を目安に応募のご意向をお知らせください。 </p><p class=\"home_layout_text_list\" data-v-68f3d595> 応募書類のつくり方や作品集のつくり方に不安な点がある場合、お気軽にご相談ください。求人企業の特徴に合わせてアドバイスします。 </p><p class=\"home_layout_text_list\" data-v-68f3d595> マスメディアンへ提出いただいた書類から複数の企業へ応募が可能です。書類作成・印刷・郵送の手間も省けます。 </p><div class=\"home_layout_link\" data-v-68f3d595><a class=\"text_link\" href=\"https://www.massmedian.co.jp/service/flow/documents.html\" target=\"_blank\" data-v-68f3d595> マスメディアン経由で応募企業へ提出する書類について ＞ </a></div><p class=\"home_layout_text\" data-v-68f3d595>＜応募書類作成マニュアル＞</p>", 37)
const _hoisted_89 = { class: "home_manual_download" }
const _hoisted_90 = ["href"]
const _hoisted_91 = { class: "home_manual_download" }
const _hoisted_92 = ["href"]
const _hoisted_93 = { class: "home_manual_download" }
const _hoisted_94 = ["href"]
const _hoisted_95 = { class: "home_manual_download" }
const _hoisted_96 = ["href"]
const _hoisted_97 = /*#__PURE__*/_createStaticVNode("<div class=\"home_layout_title\" id=\"jump_step_5\" data-v-68f3d595>STEP5 面接</div><p class=\"home_layout_text_list\" data-v-68f3d595> キャリアコンサルタントがあなたに代わって、企業と面接日程を調整します。「仕事が忙しくて、転職活動ができない」という方も、仕事を辞めずに転職活動を行うことができます。 </p><p class=\"home_layout_text_list\" data-v-68f3d595> マスメディアンでは、キャリアコンサルタントが企業面接に同席しています。各企業の面接現場を肌で知っているため、事前に実践的で細かなアドバイスが受けられます。（一部企業は除く） </p><p class=\"home_layout_text_list\" data-v-68f3d595>選考結果のフィードバックを受けられるため、次の選考での改善につなげられます。</p><div class=\"home_layout_title\" id=\"jump_step_6\" data-v-68f3d595>STEP6 内定・条件交渉・入社</div><p class=\"home_layout_text_list\" data-v-68f3d595> 入社日や給与をはじめとした各種条件面のデリケートな交渉も、キャリアコンサルタントがあなたに代わって調整します。交渉相手の企業は、やがてあなたが働く場所です。入社後の印象まで考えて、双方にとってベストな契約となるように調整します。 </p><p class=\"home_layout_text_list\" data-v-68f3d595>退職に関するアドバイスも受け付けています。</p><p class=\"home_layout_text_list\" data-v-68f3d595> 入社後もご相談やお悩みがあれば、いつでも気軽にお問い合わせください。転職の目標は「入社」ではなく、入社後の活躍やキャリアアップ、望む生活・環境を手に入れることにあります。そのために、マスメディアンを最大限に活用してください。 </p>", 8)

import { computed, PropType } from 'vue';
import { UserMenu } from '@/types';
import RESUME_PATH from '@/constants/documentPath';


export default /*#__PURE__*/_defineComponent({
  __name: 'WaitInterviewView',
  props: {
  menu: {
    type: Object as PropType<UserMenu>,
    required: true,
  },
},
  setup(__props) {

const props = __props



const mainRegTypeId = computed(() => {
  return props.menu.mainRegTypeId;
});
const mainRegTypeName = computed(() => {
  return props.menu.mainRegTypeName;
});
const areaName = computed(() => {
  return props.menu.areaName;
});
const cnslDate = computed(() => {
  return props.menu.cnslDate;
});
const interviewurl = computed(() => {
  return props.menu.interviewurl;
});

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("main", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(cnslDate)), 1),
          (_unref(mainRegTypeId) === 2)
            ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_unref(mainRegTypeName)) + "（" + _toDisplayString(_unref(areaName)) + "）", 1))
            : _createCommentVNode("", true),
          (_unref(mainRegTypeId) === 4)
            ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_unref(mainRegTypeName)) + "（" + _toDisplayString(_unref(areaName)) + "）", 1))
            : _createCommentVNode("", true),
          (_unref(mainRegTypeId) === 2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_14))
            : _createCommentVNode("", true),
          (_unref(mainRegTypeId) === 4 && _unref(interviewurl) === null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, _hoisted_20))
            : _createCommentVNode("", true),
          (_unref(mainRegTypeId) === 4 && _unref(interviewurl))
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                _createElementVNode("p", _hoisted_22, [
                  _createElementVNode("a", {
                    class: "text_link",
                    href: _unref(interviewurl),
                    target: "_blank"
                  }, _toDisplayString(_unref(interviewurl)), 9, _hoisted_23)
                ]),
                _hoisted_24,
                _hoisted_25,
                _hoisted_26,
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("button", _hoisted_28, [
                    _createElementVNode("a", {
                      class: "home_interview_note_start_button_link",
                      href: _unref(interviewurl),
                      target: "_blank"
                    }, "開始", 8, _hoisted_29)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_30, [
            _createVNode(_component_RouterLink, {
              class: "text_link",
              to: { name: 'd10' }
            }, {
              default: _withCtx(() => [
                _createTextVNode("日程の変更・キャンセル")
              ]),
              _: 1
            })
          ])
        ]),
        _hoisted_31,
        _createElementVNode("div", _hoisted_42, [
          _createElementVNode("a", {
            class: "home_manual_download_link",
            href: _unref(RESUME_PATH)['marketing'],
            download: ""
          }, "広報・宣伝・マーケティング", 8, _hoisted_43)
        ]),
        _createElementVNode("div", _hoisted_44, [
          _createElementVNode("a", {
            class: "home_manual_download_link",
            href: _unref(RESUME_PATH)['ae'],
            download: ""
          }, "営業・プロデューサー", 8, _hoisted_45)
        ]),
        _createElementVNode("div", _hoisted_46, [
          _createElementVNode("a", {
            class: "home_manual_download_link",
            href: _unref(RESUME_PATH)['creator'],
            download: ""
          }, " グラフィックデザイナー・コピーライター・Webクリエイター ", 8, _hoisted_47)
        ]),
        _createElementVNode("div", _hoisted_48, [
          _createElementVNode("a", {
            class: "home_manual_download_link",
            href: _unref(RESUME_PATH)['editor'],
            download: ""
          }, "編集者", 8, _hoisted_49)
        ])
      ]),
      _hoisted_50,
      _createElementVNode("div", _hoisted_51, [
        _hoisted_52,
        _createElementVNode("div", _hoisted_89, [
          _createElementVNode("a", {
            class: "home_manual_download_link",
            href: _unref(RESUME_PATH)['marketing'],
            download: ""
          }, "広報・宣伝・マーケティング", 8, _hoisted_90)
        ]),
        _createElementVNode("div", _hoisted_91, [
          _createElementVNode("a", {
            class: "home_manual_download_link",
            href: _unref(RESUME_PATH)['ae'],
            download: ""
          }, "営業・プロデューサー", 8, _hoisted_92)
        ]),
        _createElementVNode("div", _hoisted_93, [
          _createElementVNode("a", {
            class: "home_manual_download_link",
            href: _unref(RESUME_PATH)['creator'],
            download: ""
          }, " グラフィックデザイナー・コピーライター・Webクリエイター ", 8, _hoisted_94)
        ]),
        _createElementVNode("div", _hoisted_95, [
          _createElementVNode("a", {
            class: "home_manual_download_link",
            href: _unref(RESUME_PATH)['editor'],
            download: ""
          }, "編集者", 8, _hoisted_96)
        ]),
        _hoisted_97
      ])
    ])
  ]))
}
}

})